import React from 'react';
import './CreditSection.css';

const CreditSection = () => {
  return (
    <section className="credit-section">
      <div className="container">
        <div className="credit-content">
          <div className="credit-left">
            <h2 className="section-title">Flexible Credit with Cradly</h2>
            <p className="section-description">
              Get the financial flexibility you need with our innovative credit solutions. 
              Start your journey today with competitive rates.
            </p>
            <div className="credit-stats">
              <div className="stat-box">
                <div className="stat-value">0%</div>
                <div className="stat-label">Interest Rate</div>
              </div>
              <div className="stat-box">
                <div className="stat-value">0.0%</div>
                <div className="stat-label">Processing Fee</div>
              </div>
            </div>
            <button className="btn-primary">Apply Now</button>
          </div>
          <div className="credit-right">
            <h3 className="sub-section-title">Learn, Grow & Build</h3>
            <div className="growth-cards">
              <div className="growth-card">
                <div className="growth-icon">💼</div>
                <h4 className="growth-title">Financial Tools</h4>
              </div>
              <div className="growth-card">
                <div className="growth-icon">📈</div>
                <h4 className="growth-title">Business Growth</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreditSection;

